import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import Dashboard from '../components/Service_Tickets/Dashboard';
import EditServiceTicket from '../components/Service_Tickets/EditServiceTicket';
import ServiceTicketList from '../components/Service_Tickets/ServiceTicketList';
import ViewServiceTicket from '../components/Service_Tickets/ViewServiceTicket';



const Service_Tickets = () => {
  return (
    <Routes>
      <Route path="/" element={<ServiceTicketList />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/check_in" element={<EditServiceTicket />} />
      {/* <Route path="/edit/:id" element={<EditServiceTicket />} /> */}
      <Route path="/view/:id" element={<ViewServiceTicket />} />
    
    </Routes>
  )
}

export default Service_Tickets;